import { getDefaultHomeRoute, isAdmin, canAccessPage } from './auth/permissions';
import { ADSENSE_ENABLED } from './productWorkspace';

const KEY = 'adnexus.lastRoute';

const ALLOWED = new Set([
  '/dashboard',
  '/reporting',
  '/roi',
  '/presets',
  '/admin',
  '/domain-user',
  '/my-ads',
  '/help',
  '/ai-report',
  '/ai-forecast',
  '/admob/dashboard',
  '/admob/reporting',
  '/admob/presets',
  '/admob/roi',
  '/adsense/dashboard',
  '/adsense/reporting',
  '/adsense/presets',
  '/adsense/roi',
]);

export function rememberLastRoute(pathname) {
  const path = String(pathname || '').split('?')[0];
  if (!ALLOWED.has(path)) return;
  try {
    localStorage.setItem(KEY, path);
  } catch {
    /* ignore */
  }
}

export function readLastRoute() {
  try {
    const path = localStorage.getItem(KEY);
    return ALLOWED.has(path) ? path : null;
  } catch {
    return null;
  }
}

function routeAllowed(user, path) {
  if (!ADSENSE_ENABLED && path.startsWith('/adsense')) return false;
  if (path === '/admin') return isAdmin(user);
  if (path === '/help') return true;
  const pageMap = {
    '/dashboard': 'dashboard',
    '/reporting': 'reporting',
    '/roi': 'roi',
    '/presets': 'presets',
    '/domain-user': 'domain-user',
    '/my-ads': 'my-ads',
    '/admob/dashboard': 'admob-dashboard',
    '/admob/reporting': 'admob-reporting',
    '/admob/presets': 'admob-presets',
    '/admob/roi': 'admob-roi',
    '/adsense/dashboard': 'adsense-dashboard',
    '/adsense/reporting': 'adsense-reporting',
    '/adsense/presets': 'adsense-presets',
    '/adsense/roi': 'adsense-roi',
  };
  const page = pageMap[path];
  if (page) return canAccessPage(user, page);
  return false;
}

/** Last visited allowed page, else the role default. */
export function resolveHomeRoute(user) {
  const last = readLastRoute();
  if (last && routeAllowed(user, last)) return last;
  return getDefaultHomeRoute(user);
}
